import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast } from 'react-toastify';

export default function ManageInquiry() {

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [viewRow, setViewRow] = useState(null); // ← modal state

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetchData = () => {
    API.get(`/inquiries?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`)
      .then(res => {
        setData(res.data?.data || []);
        setTotal(res.data?.total || 0);
      });
  };

  useEffect(() => { fetchData(); }, [page]);

  const toggleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    setSelected(e.target.checked ? data.map(d => d.cont_Id) : []);
  };

  const handleDeleteSelected = async () => {
    if (selected.length === 0) { toast.error("Select at least one"); return; }
    await API.post('/inquiries/delete', { ids: selected });
    toast.success("Deleted");
    setSelected([]);
    fetchData();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    await API.delete(`/inquiries/${id}`);
    toast.success("Deleted");
    fetchData();
  };

  const totalPages = Math.ceil(total / limit);

  return (
    <Layout activePage="Inquiry">

    <div style={S.header}>
        <h2 style={S.title}>Manage Inquiry</h2>
        <p style={S.subtitle}>View and manage Inquiries</p>
      </div>

      {/* ── FILTER ── */}
      <div style={{ ...S.card, display: 'flex', alignItems: 'flex-end', gap: 12, padding: '16px 20px', backgroundColor: 'rgb(239,241,246)', marginBottom: 30 }}>
        
        <div style={S.fg}>
          <label style={S.label}>From Date</label>
          <input style={S.input} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        </div>

        <div style={S.fg}>
          <label style={S.label}>To Date</label>
          <input style={S.input} type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
        </div>

        <button onClick={() => { setPage(1); fetchData(); }} style={{ ...S.editBtn, padding: '8px 22px', height: 38 }}>
          Search
        </button>

        <button onClick={handleDeleteSelected} style={{ ...S.delBtn, padding: '8px 22px', height: 38 }}>
          Delete Selected
        </button>
      </div>

      {/* ── TABLE ── */}
      <div style={S.card}>
        <table style={S.table}>
          <thead>
            <tr style={S.theadRow}>
              <th style={S.th}>
                <input
                  type="checkbox"
                  checked={selected.length === data.length && data.length > 0}
                  onChange={handleSelectAll}
                />
              </th>
              <th style={S.th}>#</th>
              <th style={S.th}>Name</th>
              <th style={S.th}>Email</th>
              <th style={S.th}>Mobile</th>
              <th style={S.th}>Message</th>
              <th style={S.th}>Date</th>
              <th style={S.th}>View</th>
              <th style={S.th}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr><td colSpan={9} style={S.emptyCell}>No inquiries found.</td></tr>
            ) : data.map((row, i) => (
              <tr key={row.cont_Id} style={S.tr}>
                <td style={S.td}>
                  <input type="checkbox" checked={selected.includes(row.cont_Id)} onChange={() => toggleSelect(row.cont_Id)} />
                </td>
                <td style={S.td}><span style={S.serial}>{(page - 1) * limit + i + 1}</span></td>
                <td style={S.td}><span style={S.nameChip}>{row.cont_name}</span></td>
                <td style={S.td}><span style={S.groupChip}>{row.cont_email}</span></td>
                <td style={S.td}><span style={S.serial}>{row.cont_telno}</span></td>
                <td style={S.td}>
                  <span style={{ color: '#666', fontSize: 12 }}>
                    {row.cont_comment?.length > 40 ? row.cont_comment.slice(0, 40) + '…' : row.cont_comment}
                  </span>
                </td>
                <td style={S.td}>
                  {row.cont_createddate ? new Date(row.cont_createddate).toLocaleDateString() : '—'}
                </td>
                <td style={S.td}>
                  <button style={S.viewBtn} onClick={() => setViewRow(row)}>View</button>
                </td>
                <td style={S.td}>
                  <button style={S.delBtn} onClick={() => handleDelete(row.cont_Id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* ── PAGINATION ── */}
        <div style={S.pagination}>
          <span style={S.paginInfo}>Total: {total} records</span>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button style={S.pgBtn} disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
            <span style={{ fontSize: 13, color: '#666' }}>{page} / {totalPages || 1}</span>
            <button style={S.pgBtn} disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
          </div>
        </div>
      </div>

      {/* ── VIEW MODAL ── */}
      {viewRow && (
        <div style={S.overlay} onClick={() => setViewRow(null)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={S.modalHead}>
              <div>
                <div style={{ fontWeight: 800, fontSize: 17, color: '#1a1d2e' }}>Inquiry Details</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>#{viewRow.cont_Id}</div>
              </div>
              <button style={S.closeBtn} onClick={() => setViewRow(null)}>✕</button>
            </div>

            {/* Body */}
            <div style={S.modalBody}>
              <div style={S.grid2}>

                <div style={S.fg}>
                  <label style={S.label}>Full Name</label>
                  <div style={S.viewField}>{viewRow.cont_name || '—'}</div>
                </div>

                <div style={S.fg}>
                  <label style={S.label}>Email Address</label>
                  <div style={S.viewField}>{viewRow.cont_email || '—'}</div>
                </div>

                <div style={S.fg}>
                  <label style={S.label}>Mobile Number</label>
                  <div style={S.viewField}>{viewRow.cont_telno || '—'}</div>
                </div>

                <div style={S.fg}>
                  <label style={S.label}>Date Submitted</label>
                  <div style={S.viewField}>
                    {viewRow.cont_createddate ? new Date(viewRow.cont_createddate).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }) : '—'}
                  </div>
                </div>

              </div>

              <div style={S.fg}>
                <label style={S.label}>Message</label>
                <div style={{ ...S.viewField, minHeight: 80, whiteSpace: 'pre-wrap', lineHeight: 1.7 }}>
                  {viewRow.cont_comment || '—'}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div style={S.modalFoot}>
              <button style={S.cancelBtn} onClick={() => setViewRow(null)}>Close</button>
              <button style={S.delBtn} onClick={() => { handleDelete(viewRow.cont_Id); setViewRow(null); }}>
                Delete
              </button>
            </div>

          </div>
        </div>
      )}

    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root: { display: 'flex', minHeight: '100vh', background: '#f4f6fb', fontFamily: "'DM Sans','Segoe UI',sans-serif" },
  main: { flex: 1, padding: '28px 28px 40px', minWidth: 0 },

   /* Header */
   header: { marginBottom: 20 },
   title: { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
   subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },
 
  card: { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse' },
  theadRow: { background: '#fafafa' },
  th: { padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999', textAlign: 'center', borderBottom: '2px solid #f0f0f0', textTransform: 'uppercase', letterSpacing: '0.5px' },
  tr: { transition: 'background 0.12s' },
  td: { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
  emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },
  serial:    { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
  nameChip:  { background: '#f0fff6', color: '#1a9e5c', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
  groupChip: { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
  viewBtn: { marginRight: 5, background: '#f0fff6', color: '#1a9e5c', border: '1px solid #b8f0d0', padding: '4px 12px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  editBtn: { background: '#f3f2ff', color: '#6C63FF', border: '1px solid #d4d0ff', padding: '4px 12px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  delBtn:  { background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8', padding: '4px 12px', borderRadius: 20, cursor: 'pointer', fontSize: 12, fontWeight: 700, fontFamily: 'inherit' },
  pagination: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px', borderTop: '1px solid #f0f0f0' },
  paginInfo: { fontSize: 12, color: '#999' },
  pgBtn: { padding: '5px 14px', background: '#f3f2ff', color: '#6C63FF', border: '1px solid #d4d0ff', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, fontFamily: 'inherit' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)' },
  modalBox: { background: '#fff', borderRadius: 20, width: 580, maxWidth: '96vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 60px rgba(0,0,0,0.2)' },
  modalHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px', borderBottom: '1px solid #f0f0f0' },
  modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
  modalFoot: { display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 22px', borderTop: '1px solid #f0f0f0' },
  closeBtn:  { background: '#ff6b6b22', border: 'none', color: '#ff6b6b', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontWeight: 800, fontSize: 14 },
  cancelBtn: { padding: '9px 20px', background: '#f5f5f5', color: '#666', border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 },
  fg: { display: 'flex', flexDirection: 'column', gap: 5 },
  label: { fontSize: 12, fontWeight: 600, color: '#555' },
  input: { padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none', width: '100%', boxSizing: 'border-box' },
  viewField: { background: '#f8f8fc', border: '1.5px solid #efefef', borderRadius: 8, padding: '9px 12px', fontSize: 13, color: '#333', minHeight: 38 },
};